import { css, styled } from '@mui/material/styles';
import { Box } from '@mui/material';

interface CardMeetingProps {
  status: Date | undefined;
}

export const CardMeeting = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px 20px;
  gap: 15px;
  height: 167px;
  width: 100%;
  border-radius: 6px;
  // background: #ffffff;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  z-index: 1;

  :hover {
    background: #eeeeee;
    transition: background 0.2s;
  }

  ${(props: CardMeetingProps) =>
    props.status !== null &&
    css`
      border-color: red;

      :hover {
        background: #ffc9d680;
        transition: background 0.2s;
      }
    `}

  .desc-meeting {
    display: flex;
    flex-direction: column;
    list-style: none;
    gap: 3px;
  }

  h3 {
    margin: 0;
  }

  li {
    list-style: none;
  }

  .day-meeting {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 52px;
    line-height: 22px;
    display: flex;
    align-items: center;
    letter-spacing: 0.15px;
  }

  .month-meeting {
    font-style: normal;
    font-weight: 400;
    font-size: 19px;
    line-height: 29px;
  }

  .duration-meeting {
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 700;
    font-size: 15px;
    line-height: 16px;
    display: flex;
    align-items: center;
    text-align: center;
    flex-direction: row;
  }

  .date-meeting {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    justify-content: center;
    height: 100%;
    width: 150px;
    padding: 0;
    margin: 0;
    gap: 10px;
    border-right: 1px solid #d0d0d0;
    padding-right: 20px;
  }

  .btn-zoom {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 6px 16px;
    width: 172px;
    height: 36px;
    background: #206da7;
    border-radius: 4px;
    white-space: nowrap;
  }

  .btn-meeting {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 6px 16px;
    width: 172px;
    height: 36px;
    border: 1px solid #206da7;
    border-radius: 4px;
    white-space: nowrap;
    z-index: 999;
  }

  .icon-edit {
    font-size: 2rem;
    color: ${({ theme }) => theme.palette.primary.main};
  }

  .status {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 5px;
  }
`;

export const Div = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  height: 100%;
  gap: 20px;
`;

export const Content = styled(Box)`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 167px;
  flex-direction: column;
  flex: 1;
  gap: 20px;

  a {
    text-decoration: none;
  }
`;

export const Status = styled(Box)`
  text-decoration: none;
  padding: 0;
  margin: 0;
  color: #ffffff;
  border-radius: 50px;
  width: fit-content;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 4px 10px;
  height: 28px;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  letter-spacing: 0.15px;
  white-space: nowrap;
`;

export const Typography = styled(Box)`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 32px;
  display: flex;
  align-items: center;
  text-align: center;
  letter-spacing: 0.15px;
  color: #000000;
  white-space: nowrap;
`;

export const Guest = styled(Box)`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  white-space: nowrap;
  text-align: center;
  letter-spacing: 0.4px;
  color: #616161;
`;

export const Recurrence = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 10px;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: #0b79d0;
`;

export const ListUsers = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 6px;

  width: 100%;
`;

export const Li = styled(Box)``;
